import { EntityFilter, IncomeCategory } from '@easy-expense/data-schema-v2';
import Data from '@easy-expense/frontend-data-layer';
import { getTranslation } from '@easy-expense/intl-client';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import { useClientUsageCounts, useIncomeCategoryUsageCounts } from '@easy-expense/utils-client';
import React from 'react';

import { SearchDropdown } from '../Shared/Dropdown/SearchDropDown.component';
import { deletedAutoCompleteValues } from '../Shared/deletedAutoCompleteValues';
import { useDeletedInUse } from '../Shared/useDeletedInUse';

export const ExportIncomeFilters: React.FC<{
  entityFilter: EntityFilter;
  setExportFilters: (filters: EntityFilter) => void;
}> = ({ entityFilter, setExportFilters }) => {
  const allClients = Data.clients.use();
  const incomeCategories: IncomeCategory[] = Data.incomeCategories.use();

  // Deleted entries stay filterable while incomes are still filed against them.
  const deletedClients = useDeletedInUse(useClientUsageCounts(), Data.clients.getByKey, allClients);
  const deletedIncomeCategories = useDeletedInUse(
    useIncomeCategoryUsageCounts(),
    Data.incomeCategories.getByKey,
    incomeCategories,
  );

  return (
    <Layout.Column>
      <Layout.Row align>
        <OpenSans.Primary size={22} weight="bold-700">
          {getTranslation('Income Filters')}
        </OpenSans.Primary>
      </Layout.Row>
      <Spacer.Vertical size={8} />
      <Layout.Row align>
        <SearchDropdown
          header={getTranslation('Clients')}
          placeholder={getTranslation('All Clients')}
          selectedKey={entityFilter.clients?.length ? entityFilter.clients[0] : null}
          autoCompleteValues={[
            { key: undefined, value: { name: 'All Clients', iconicIcon: 'person-outline' } },
            ...allClients,
            ...deletedAutoCompleteValues(deletedClients, 'person-outline'),
          ]}
          onSelect={(c) => {
            setExportFilters({ ...entityFilter, clients: c?.key ? [c.key] : null });
          }}
          error={false}
          iconicIcon="person-outline"
          clearOnSelect={true}
        />
        <Spacer.Horizontal />

        <SearchDropdown
          header={getTranslation('Income Categories')}
          placeholder={getTranslation('All Income Categories')}
          selectedKey={
            entityFilter.incomeCategories?.length ? entityFilter.incomeCategories[0] : null
          }
          autoCompleteValues={[
            {
              key: undefined,
              value: { name: 'All Income Categories', iconicIcon: 'pricetag-outline' },
            },
            ...incomeCategories,
            ...deletedAutoCompleteValues(deletedIncomeCategories, 'pricetag-outline'),
          ]}
          onSelect={(c) => {
            setExportFilters({ ...entityFilter, incomeCategories: c?.key ? [c.key] : null });
          }}
          error={false}
          iconicIcon="pricetag-outline"
          clearOnSelect={true}
        />
      </Layout.Row>

      <Spacer.Vertical size={16} />
    </Layout.Column>
  );
};
